import { InstiComponent } from './insti.component';
import { Injectable } from '@angular/core';
import {InstiHelpers} from './instihelpers.module';
import { AtmMenu} from './atmMenu';
import { InstiService } from './insti.service';
import { BaseOrcService } from '../natureza51/sistema-orcamentario/base-orc.service';
import { HttpClient } from '@angular/common/http';
import { environment} from '../../environments/environment';

//import {InstiHelpers} from './instihelpers.module';
//export const insti_helpers=new InstiHelpers();

@Injectable()
export class InstiMenu {
    private teste:any={ "id":1,
                        "menu": "Lateral",
                        "descricao" : "Menu Lateral",
                        "status" : 1,
                        "itens": [{
                                    "id" : 1,
                                    "menu_id" : 1,
                                    "parent_id" : null,
                                    "label" : "Sis. Orçamentário",
                                    "tipo" : "saperator",
                                    "icone" : "book",
                                    "url_fragment" : null,
                                    "url_base" : null,
                                    },
                                    {
                                    "id" : 2,
                                    "menu_id" : 1,
                                    "parent_id" : 1,
                                    "label" : "Orçamento",
                                    "tipo" : "link",
                                    "icone" : "book",
                                    "url_fragment" : "natureza51\/orcamento",
                                    "url_base" : null,

                                    },
                                    {
                                    "id" : 3,
                                    "menu_id" : 1,
                                    "parent_id" : 1,
                                    "label" : "HeadCount",
                                    "tipo" : "link",
                                    "icone" : "book",
                                    "url_fragment" : "natureza51\/headcount",
                                    "url_base" : "",
                                    },
                                {
                                    "id" : 8,
                                    "menu_id" : 1,
                                    "parent_id" : null,
                                    "label" : "Cadastros",
                                    "tipo" : "saperator",
                                    "icone" : "insert_drive_file",
                                    "url_fragment" : "",
                                    "url_base" : "natureza51",
                                    "tela_id" : 0,
                                    "tag_id" : 0,
                                },
                                    {
                                    "id" : 10,
                                    "menu_id" : 1,
                                    "parent_id" : 8,
                                    "label" : "Funcionário",
                                    "tipo" : "link",
                                    "icone" : "book",
                                    "url_fragment" : "funcionario\/listar",
                                    "url_base" : null,
                                    },
                                  
                                    {
                                      "id" : 11,
                                      "menu_id" : 1,
                                      "parent_id" : 8,
                                      "label" : "Com sub",
                                      "tipo" : "sub",
                                      "icone" : "book",
                                      "url_fragment" : "funcionario\/listar",
                                      "url_base" : null,
                                      },
                                      {
                                        "id" : 12,
                                        "menu_id" : 1,
                                        "parent_id" : 11,
                                        "label" : "sub01",
                                        "tipo" : "link",
                                        "icone" : "book",
                                        "url_fragment" : "funcionario\/listar",
                                        "url_base" : null,
                                        },
                                        {
                                          "id" : 13,
                                          "menu_id" : 1,
                                          "parent_id" : 11,
                                          "label" : "sub02",
                                          "tipo" : "link",
                                          "icone" : "book",
                                          "url_fragment" : "funcionario\/listar",
                                          "url_base" : null,
                                          },
                                  ]
                    };
                  

    private teste_finplan= { "id":2,
    "menu": "FIN PLAN",
    "descricao" : "MENU DO FIM PLAN",
    "status" : 1,
    "itens": [{
                "id" : 1,
                "menu_id" : 1,
                "parent_id" : null,
                "label" : "Finplan",
                "tipo" : "saperator",
                "icone" : "book",
                "url_fragment" : null,
                "url_base" : null,
                },
                {
                "id" : 2,
                "menu_id" : 2,
                "parent_id" : 1,
                "label" : "Item 01",
                "tipo" : "extLink",
                "icone" : "book",
                "url_fragment" : "natureza51\/headcount",
                "url_base" : null,

                },
                {
                "id" : 3,
                "menu_id" : 2,
                "parent_id" : 1,
                "label" : "HeadCount",
                "tipo" : "extLink",
                "icone" : "book",
                "url_fragment" : "natureza51\/headcount",
                "url_base" : "",
                },
            {
                "id" : 8,
                "menu_id" : 2,
                "parent_id" : null,
                "label" : "Item 01",
                "tipo" : "saperator",
                "icone" : "insert_drive_file",
                "url_fragment" : "",
                "url_base" : "natureza51",
                "tela_id" : 0,
                "tag_id" : 0,
            },
                {
                "id" : 10,
                "menu_id" : 1,
                "parent_id" : 8,
                "label" : "Sum item 1-1",
                "tipo" : "extLink",
                "icone" : "book",
                "url_fragment" : "funcionario\/listar",
                "url_base" : null,
                },
              
                {
                  "id" : 11,
                  "menu_id" : 2,
                  "parent_id" : 8,
                  "label" : "Item 1-2 Com sub",
                  "tipo" : "sub",
                  "icone" : "book",
                  "url_fragment" : "funcionario\/listar",
                  "url_base" : null,
                  },
                  {
                    "id" : 12,
                    "menu_id" : 2,
                    "parent_id" : 11,
                    "label" : "item 1-2-1",
                    "tipo" : "extLink",
                    "icone" : "book",
                    "url_fragment" : "funcionario\/listar",
                    "url_base" : null,
                    },
                    {
                      "id" : 13,
                      "menu_id" : 2,
                      "parent_id" : 11,
                      "label" : "item 1-2-2",
                      "tipo" : "extLink",
                      "url_fragment" : "funcionario\/listar",
                      "url_base" : null,
                      },
              ]
    };
    private menu:any;
    private menu_itens:any[];
    private processed_menu_item:AtmMenu[];
  
  
    hasMenu():Boolean{ return !this.menu ? false : true; } 
  hasItens():Boolean{ 
       let a=this.menu_itens;
       if(!Array.isArray(a)){
           return false;
       }
       return a.length>0;
   }
  private getMenuItensFromMenu(){
      let menu=this.getMenu();
          if(!menu){
          return [];
      }
      if(!menu.hasOwnProperty('itens')){
          return [];
      }
      if(!Array.isArray(menu.itens)){
          return [];
      }

      return menu.itens;      
  }   
  private setMenu(value){ 
      this.menu=value;
      return this;
  } 
  
  private setMenuItens(value){
      this.menu_itens=this.hasMenu()? value: [];
      return this.process();
  } 
  /**
   * @Author Aluisio Ferreira de Sousa 
   * atmmaster36@yahoo.com.br
   * @Description Transforma o Json vindo da API para o formato 
   */
   private process(){
        
      let itens=this.getMenuItens();
      this.processed_menu_item=[];
      
      if(!itens){
        return this;   
      }

      let retorno:any=[];
      let childrens=[];
      let parents=itens.filter(function(current){
            if(!current.parent_id){
              return true;
             }
             childrens.push(current);
             return false;
        });
      
      let limit=parents.length;
       
      for(let x=0; x<limit; x++){
        let menuObj= new AtmMenu(parents[x], childrens);
        retorno.push(menuObj);
        
        if(menuObj.hasSiblings()){

        }

        menuObj.getSiblings().map(function(curr){
          retorno.push(curr);
          return curr;
        });

      }      
      
      this.processed_menu_item=retorno;
      return this;
   }
  /**
   * @Author Aluisio Ferreira de Sousa 
   * atmmaster36@yahoo.com.br
   * Busca atraves da api os dados do menu
   */
  load(menu_id,serviceInstance:BaseOrcService){

      //let response=menu_id==1? this.teste : this.teste_finplan;
      let instance = this;
      //let login = JSON.parse(localStorage.getItem('dados_login'));
      let insti_component = new InstiComponent();
       let a = serviceInstance.doHttp(`api/menu-item/${menu_id}`,'get',(res)=>{      
         
        let i = 0;
        let itens = [];
        for (const it of res['itens']) { 
          if(it['tipo']== 'extLink') {
            itens.push(it);
            continue;
          }
           if(!insti_component.getFilterPermissoesMenu(it['tag_id'],it['tela_id'])){
             if(!(it['tag_id'] == 0 && it['tela_id'] == 0)){
              //  res['itens'][i]['label'] = 'Sem Permissão';
              //  res['itens'][i]['url_fragment'] = 'natureza51/dashboard-gestor';
              //  res['itens'].splice(i,1);
             }
             else{
              itens.push(it);
             }
           }
           else{
             itens.push(it);
           }
           i++;
        }
        res['itens'] = itens;
        //  for(let i = 0; i < res['itens'].length; i++){
        //  }
        
        instance.setMenuItens(instance.setMenu(menu_id==1? res : instance.teste_finplan)
      .getMenuItensFromMenu());
      });

      return this;
      // return instance.setMenuItens(instance.setMenu(menu_id==1? instance.teste : instance.teste_finplan)
      // .getMenuItensFromMenu());
  
  } 
/**
   * @Author Aluisio Ferreira de Sousa 
   * atmmaster36@yahoo.com.br
   * 
   */
   getMenu(){ return !this.hasMenu()? null :  this.menu;}
  /**
   *@Author  Aluisio Ferreira de Sousa
   *atmmaster36@yahoo.com.br
   * Retorna todos os itens do menu atual
   * @return ANY[]/Menu
   */
  getMenuItens(){
      return this.hasItens() ? this.menu_itens : [];
    //return  MENUITEMS;
  }
  getRenderizedItens(){
     return this.processed_menu_item
  }


  
  
}
